import { AiPromptIcon } from '@components/ArtBoard/Header/components/ProjectMenu/components/FileContent/components/components'
import { DropdownMenu } from '@octopus-do/octopus-storybook'
import {
  Code,
  CodeInline,
  FigmaLogo,
  Image,
  Pdf,
  Plug,
  Table,
  TableExcel,
  Text,
  TextWord,
  WordpressLogo,
} from '@octopus-do/octopus-storybook/icons'
import type React from 'react'

export const FreeExportContent: React.FC = () => (
  <>
    <DropdownMenu.Button icon={AiPromptIcon} id="ai_prompt" title="Ai prompt" />
    <DropdownMenu.Button icon={FigmaLogo} id="figma" title="Figma" />
    <DropdownMenu.Button
      icon={WordpressLogo}
      id="wordpress"
      title="WordPress"
    />
    <DropdownMenu.Button icon={Code} id="sitemap" title="Sitemap.xml" />
    <DropdownMenu.BadgedButton
      type="pro"
      icon={CodeInline}
      id="upgrade"
      title="XML"
    />
    <DropdownMenu.BadgedButton type="pro" icon={Pdf} id="upgrade" title="PDF" />
    <DropdownMenu.BadgedButton
      type="pro"
      icon={Image}
      id="upgrade"
      title="PNG"
    />
    <DropdownMenu.BadgedButton
      type="pro"
      icon={Table}
      id="upgrade"
      title="CSV"
    />
    <DropdownMenu.BadgedButton
      type="pro"
      icon={TableExcel}
      id="upgrade"
      title="Excel"
    />
    <DropdownMenu.BadgedButton
      type="pro"
      icon={Text}
      id="upgrade"
      title="TXT"
    />
    <DropdownMenu.BadgedButton
      type="pro"
      icon={TextWord}
      id="upgrade"
      title="Word"
    />
    <DropdownMenu.Divider />
    <DropdownMenu.A
      href="https://help.octopus.do/article/140-develop-your-own-plugin"
      icon={Plug}
      title="Develop your plugin"
    />
  </>
)
